export enum PricingProductId {
	ScreenAndProtect = 1,
	Screening = 2,
	PetProtection = 3,
}
